/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { types } from "./actions";

const initialState = {
  list: [],
  error: null,
  loading: false,
  loaded: false,
  total: 0,
  selectedCompanyForPlayer: null,
  playerList: [],
  playerRestrictionList: [],
  successResponse: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_PLAYERS: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_PLAYERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.payload,
      };
    }
    /* istanbul ignore next */
    case types.FETCH_PLAYERS_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    /* istanbul ignore next */
    case types.FETCH_A_PLAYER: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    /* istanbul ignore next */
    case types.FETCH_A_PLAYER_SUCCESS: {
      const id = action.payload.configId;

      return {
        ...state,
        loading: false,
        loaded: true,
        entities: {
          ...state.entities,
          [id]: action.payload,
        },
      };
    }

    /* istanbul ignore next */
    case types.FETCH_A_PLAYER_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_A_PLAYER_V3: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    /* istanbul ignore next */
    case types.FETCH_A_PLAYER_V3_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: {
          ...state.entities,
          [action.payload.id]: action.payload,
        },
      };
    }
    /* istanbul ignore next */
    case types.FETCH_A_PLAYER_V3_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }

    /* istanbul ignore next */
    case types.UPDATE_SELECTED_COMPANY_FOR_PLAYER: {
      return {
        ...state,
        selectedCompanyForPlayer: action.payload,
      };
    }
    case types.FETCH_PLAYER_LIST: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    /* istanbul ignore next */
    case types.FETCH_PLAYER_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        playerList: action.payload,
      };
    }
    /* istanbul ignore next */
    case types.FETCH_PLAYER_LIST_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.DELETE_PLAYER_ENTITIES: {
      delete state.entities;
      return {
        ...state,
      };
    }
    case types.FETCH_PLAYER_FROM_DATAPIPE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: action.payload,
      };
    }
    case types.REMOVE_PLAYER_ENTITIES: {
      const copyEntities = { ...state, entities: { ...state.entities } };
      const { [action.payload]: removedEntity, ...newEntities } =
        copyEntities.entities;

      return {
        ...copyEntities,
        entities: newEntities,
      };
    }
    case types.INTIAL_PLAYER_ENTITIES: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: action.payload,
      };
    }
    case types.FETCH_PLAYER_RESTRICTION_LIST: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    /* istanbul ignore next */
    case types.FETCH_PLAYER_RESTRICTION_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        playerRestrictionList: action.payload,
      };
    }
    /* istanbul ignore next */
    case types.FETCH_PLAYER_RESTRICTION_LIST_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.CLEAR_PLAYER_RESTRICTION_LIST: {
      return {
        ...state,
        loading: false,
        loaded: false,
        playerRestrictionList: [],
        successResponse: null,
      };
    }
    case types.CLEAR_PLAYER_LIST: {
      return {
        ...state,
        loading: false,
        loaded: false,
        list: [],
      };
    }
    case types.CREATE_PLAYER_RESTRICTION: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.CREATE_PLAYER_RESTRICTION_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        successResponse: action.payload,
      };
    }
    case types.CREATE_PLAYER_RESTRICTION_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.DELETE_PLAYER_RESTRICTION: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.DELETE_PLAYER_RESTRICTION_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        successResponse: action.payload,
      };
    }
    case types.DELETE_PLAYER_RESTRICTION_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    default:
      return state;
  }
}
